<tiime-dialog [isLoading]="isLoading()" loaderPosition="end" (cancel)="cancel()">
  <mat-dialog-content class="dialog-content" mat-dialog-content data-cy="mission-acceptance-dialog-content">
    <div class="dialog-left-content">
      <div class="left-content-header">
        <div class="flex row align-center gap-10">
          <app-mission-acceptance-status-select
            label=""
            [selectData]="statuses$ | async"
            [status]="missionAcceptanceForm.controls.missionAcceptanceStatus.value"
            [statusId]="missionAcceptanceForm.controls.id.value"
            [statusAt]="missionAcceptanceForm.controls.statusAt.value"
            [statusBy]="missionAcceptanceForm.controls.statusBy.value"
            (selectionChange)="changeMissionAcceptanceStatus($event)"
          ></app-mission-acceptance-status-select>
          @if (canValidateMission()) {
            <button tiime-button strocked icon color="primary" tiimeTooltip="Valider" (click)="validate()">
              <mat-icon svgIcon="icon-check"></mat-icon>
            </button>
            <button tiime-button strocked icon color="warn" tiimeTooltip="Refuser" (click)="refuse()">
              <mat-icon fontSet="fontastic" fontIcon="icon-ic-close"></mat-icon>
            </button>
          }
          @if (canUnlockMission()) {
            <button tiime-button strocked icon color="primary" tiimeTooltip="Déverrouiller" (click)="unlock()">
              <mat-icon>lock_open</mat-icon>
            </button>
          }
          @if (missionAcceptanceForm.controls.id.value) {
            <button
              tiime-button
              strocked
              icon
              color="primary"
              [tiimeTooltip]="downloadMissionAcceptancePdfTooltip()"
              (click)="downloadMissionAcceptancePdf()"
              [disabled]="!canDownloadMissionAcceptancePdf()"
            >
              <mat-icon fontSet="fontastic" fontIcon="icon-download-24"></mat-icon>
            </button>
          }
        </div>
      </div>
      <div tiimeProperties>
        <div>
          <div tiimeLargeProperty>Structure juridique :</div>
          <div tiimeProperty>
            <span class="nowrap">Dénomination</span>
            <span class="italic ellipsis" tiimeFallbackText>
              {{ missionAcceptanceForm.controls.legalStructure.value?.name }}
            </span>
          </div>
        </div>
        <div>
          <div tiimeLargeProperty>Expert-comptable signataire :</div>
          <app-signatory-select
            class="control-container"
            label=""
            [selectData]="signatories()"
            [control]="missionAcceptanceForm.controls.signatory"
            [errorMessage]="missionAcceptanceForm.signatoryErrorMessage"
          ></app-signatory-select>
        </div>
        <app-company-properties
          [company]="company()"
          [taxRegimes]="taxRegimes$ | async"
          [vatSystems]="vatSystems$ | async"
          [displayedProperties]="companyDisplayedProperties"
          [showRefresh]="!missionAcceptanceForm.disabled"
          (refreshCompany)="refreshCompanyFields()"
        ></app-company-properties>
        <div>
          <div tiimeLargeProperty>
            Contact :
            @if (!missionAcceptanceForm.disabled) {
              <app-refresh-button (refresh)="refreshContactFields()"></app-refresh-button>
            }
          </div>
          <app-user-select
            [control]="missionAcceptanceForm.controls.contact"
            [selectData]="users()"
            [errorMessage]="missionAcceptanceForm.contactErrorMessage"
            label=""
            (create)="openCreateUserDialog()"
            [allowEmptyOption]="false"
            [allowCreateOption]="true"
            createOptionLabel="Ajouter un contact"
          ></app-user-select>
          @if (missionAcceptanceForm.controls.contact.value) {
            <div class="phone-property" tiimeIconProperty>
              <mat-icon svgIcon="icon-phone"></mat-icon>
              <span class="italic ellipsis" tiimeFallbackText>
                {{ missionAcceptanceForm.controls.contactPhone.value | phone }}
              </span>
            </div>
            <div tiimeIconProperty>
              <mat-icon svgIcon="icon-mail"></mat-icon>
              <span
                class="italic ellipsis"
                [tiimeTooltip]="missionAcceptanceForm.controls.contactEmail.value"
                tiimeFallbackText
              >
                {{ missionAcceptanceForm.controls.contactEmail.value }}
              </span>
            </div>
            <app-address-property
              tiimeIconProperty
              [street]="missionAcceptanceForm.controls.contactStreet.value"
              [postalCode]="missionAcceptanceForm.controls.contactPostalCode.value"
              [city]="missionAcceptanceForm.controls.contactCity.value"
            ></app-address-property>
          }
        </div>
      </div>
      @if (missionAcceptanceForm.controls.contact?.value?.id) {
        <div class="actions">
          <button
            tiime-button
            color="primary"
            strocked
            tiimeTooltip="Ouvrir dans un nouvel onglet"
            (click)="openGoogleLinkInNewTab()"
          >
            Google
            <mat-icon fontSet="fontastic" fontIcon="icon-open-in-new-window-2"></mat-icon>
          </button>
          <button
            tiime-button
            color="primary"
            strocked
            tiimeTooltip="Ouvrir dans un nouvel onglet"
            (click)="openDirectoryLinkInNewTab()"
          >
            Annuaire
            <mat-icon fontSet="fontastic" fontIcon="icon-open-in-new-window-2"></mat-icon>
          </button>
          <button
            tiime-button
            color="primary"
            icon
            strocked
            tiimeTooltip="Autres actions"
            [matMenuTriggerFor]="missionAcceptanceDialogActions"
          >
            <mat-icon inline="true" fontSet="fontastic" fontIcon="icon-more" />
          </button>
          <mat-menu #missionAcceptanceDialogActions="matMenu">
            <div mat-menu-item (click)="openPappersLinkInNewTab()">
              <mat-icon fontSet="fontastic" fontIcon="icon-open-in-new-window-2" matMenuItemIcon />
              Pappers
            </div>
          </mat-menu>
        </div>
      }
    </div>
    <div class="dialog-right-content">
      <span mat-dialog-title>
        @if (missionAcceptanceForm.controls.id?.value) {
          Détails de l'acceptation de mission
        } @else {
          Ajouter une acceptation de mission
        }
      </span>
      <form class="mission-acceptance-form" [formGroup]="missionAcceptanceForm">
        <tiime-tabs>
          <tiime-tab>
            <tiime-tab-title>
              Informations
              <app-mission-acceptance-form-status-icon
                [invalid]="missionAcceptanceForm.controls.informations.invalid"
              ></app-mission-acceptance-form-status-icon>
            </tiime-tab-title>
            <app-informations-form
              [types]="types$ | async"
              [fileTypes]="fileTypes$ | async"
              [users]="users()"
              [canAddContractLdmFromContract]="canAddContractLdmFromContract()"
              [identityPieceIsNeededAndMissing]="missionAcceptanceForm.identityPieceIsNeededAndMissing"
              (removeFile)="removeFile($event)"
              (downloadFile)="downloadFile($event)"
              (openFileInNewTab)="openFileInNewTab($event)"
              (onFileSelected)="onFileSelected($event)"
              (addContractFile)="openAddContractFileDialog()"
            ></app-informations-form>
          </tiime-tab>
          <tiime-tab>
            <tiime-tab-title>
              Acceptation
              <app-mission-acceptance-form-status-icon
                [invalid]="missionAcceptanceForm.controls.acceptation.invalid"
              ></app-mission-acceptance-form-status-icon>
            </tiime-tab-title>
            <app-acceptation-form [riskLevels]="riskLevels$ | async"></app-acceptation-form>
          </tiime-tab>
          <tiime-tab>
            <tiime-tab-title>
              L.A.B
              <app-mission-acceptance-form-status-icon
                [invalid]="missionAcceptanceForm.controls.antiMoneyLaundering.invalid"
              ></app-mission-acceptance-form-status-icon>
            </tiime-tab-title>
            <app-anti-money-laundering-form
              [formGroup]="missionAcceptanceForm.controls.antiMoneyLaundering"
            ></app-anti-money-laundering-form>
          </tiime-tab>
        </tiime-tabs>
      </form>
      <div class="actions">
        <button tiime-button color="accent" strocked (click)="cancel()" data-cy="mission-acceptance-dialog-cancel-btn">
          Annuler
        </button>
        <button
          tiime-button
          color="accent"
          raised
          [disabled]="missionAcceptanceForm.disabled"
          (click)="submitMissionAcceptance()"
          data-cy="mission-acceptance-dialog-save-btn"
        >
          {{ missionAcceptanceForm.controls.id?.value ? 'Enregistrer' : 'Ajouter' }}
        </button>
      </div>
    </div>
  </mat-dialog-content>
</tiime-dialog>
